import getclassNames from "../../../utils/getClassNames";
import Button from "../../UI/Button";
import ReportStepProps from "./ReportStepProps";
import { format, isMatch, parse } from "date-fns";
import IconButton from "../../UI/IconButton";
import { ACTIVITY_DATE_RANGE } from "../../../constants/reportStep";
import Input from "../../UI/Input";
import { isValidISODate } from "../../../utils/dateHelpers";

const ACTIVITY_FROM_DATE = 'activity_from_date';
const ACTIVITY_TO_DATE = 'activity_to_date';

const ActivityDateRange = (props: ReportStepProps) => {
    const handleToggleExpanded = () => {
        props.onExpand(ACTIVITY_DATE_RANGE, !props.expanded);
    };

    const handleOnChange = (fieldName: string, value: string) => {
        const fieldExists = props.values.some(v => v.name === fieldName);

        const newValues = fieldExists 
            ? props.values.map(v => v.name === fieldName ? { ...v, value } : v)
            : [...props.values, { name: fieldName, value }];

        props.onChange({ 
            step: ACTIVITY_DATE_RANGE,
            values: newValues
        });
    };

    const handleOnNext = () => {
        props.onNext(ACTIVITY_DATE_RANGE);
    };

    const fromDate = props.values.find(v => v.name === ACTIVITY_FROM_DATE)?.value || '';
    const toDate = props.values.find(v => v.name === ACTIVITY_TO_DATE)?.value || '';
    const formattedFromDate = !fromDate || !isMatch(fromDate, 'yyyy-MM-dd') ?
        '' : 
        format(parse(fromDate, 'yyyy-MM-dd', new Date()), 'MM/dd/yyyy');
    const formattedToDate = !toDate || !isMatch(toDate, 'yyyy-MM-dd') ? 
        '' :
        format(parse(toDate, 'yyyy-MM-dd', new Date()), 'MM/dd/yyyy');
    const hasInvalidDate = (fromDate !== '' && !isValidISODate(fromDate)) || (toDate !== '' && !isValidISODate(toDate));
        
    return (<div className={getclassNames('report-step', props.expanded ? 'expanded' : '')}>
    <div className="report-step-header">
        <div className="row justify-content-between align-items-center">
            <div className="column-auto">
                <h3>Select a date range{formattedFromDate && formattedToDate ? ` - ${formattedFromDate} to ${formattedToDate}` : ''}</h3>
            </div>
            <div className="column-1">
                <IconButton id="toggle-report-perspective-expansion"
                    className="small flat"
                    disabled={props.disabled}
                    icon={props.expanded ? (<i className="ri-arrow-up-s-line"></i>) : (<i className="ri-arrow-down-s-line"></i>)}
                    onClick={handleToggleExpanded} />
            </div>
        </div>
    </div>
    <div className="report-step-body">
        <div className="row margin-bottom-3">
            <div className="column">
                <div className="row">
                    <div className="column">
                        <Input id="date-range-from"
                            type="date"
                            label="Activity From Date"
                            value={fromDate}
                            onChange={(v) => handleOnChange(ACTIVITY_FROM_DATE, v)} />
                    </div>
                    <div className="column">
                        <Input id="date-range-to"
                            type="date"
                            label="Activity To Date"
                            value={toDate}
                            onChange={(v) => handleOnChange(ACTIVITY_TO_DATE, v)} />
                    </div>
                </div>
            </div>
        </div>
        {hasInvalidDate && <p className="text-danger">Enter valid dates in YYYY-MM-DD format with a four-digit year.</p>}
        <div className="row justify-content-end margin-bottom-3">
            <div className="column-auto">
                <Button id="report-type-next"
                    text="Next"
                    icon={<i className="ri-arrow-right-s-line"></i>}
                    iconLocation="end"
                    className="secondary"
                    disabled={!fromDate || !toDate || hasInvalidDate || props.disabled}
                    onClick={handleOnNext} />
            </div>
        </div>
    </div>
</div>);
};

export default ActivityDateRange;
